<template>
  <div class="exam_content">
    <div class="exam_con">
      <h2 class="exam_con_t">个人资料</h2>
      <div class="person_left">
        <span class="person_img">
          <img :src="userInfo.faceUrl" width="230" height="230" />
        </span>
        <el-button
          v-if="userInfo.faceStatus !== 3"
          size="small"
          type="primary"
          class="pers_btna"
          @click="showUpload()"
          >点击拍照</el-button
        >
        <!-- <el-upload
          class="upload-demo"
          action="#"
          :show-file-list="false"
          :http-request="fileUpload"
        >
          <el-button
            size="small"
            type="primary"
            class="pers_btna pers_btn1"
            v-if="userInfo.faceStatus !== 3"
            >本地上传</el-button
          >
        </el-upload> -->
        <upload
          v-if="uploadVisible"
          ref="upload"
          @refreshData="initData()"
          :imgSrc1="userInfo.faceUrl"
        />
      </div>
      <div class="person_right">
        <ul>
          <li><span>考生姓名:</span>{{ userInfo.userName }}</li>
          <li><span>考生性别:</span>{{ userInfo.sex }}</li>
          <li><span>身份证号:</span>{{ userInfo.idCardNo }}</li>
          <li><span>考生学号:</span>{{ userInfo.studentNo }}</li>
          <li><span>准考证号:</span>{{ userInfo.certNo }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { myInfo, updPwd, addPerson } from "@/api/login";
import upload from "./upload";
export default {
  name: "Profile",
  components: {
    upload
  },
  data() {
    return {
      tokenBean: {
        token: ""
      },
      pwdBean: {
        token: "",
        oldPwd: "",
        loginPwd: ""
      },
      faceBean: {
        fileBase64: "",
        extName: "",
        token: ""
      },
      loginPwd2: "",
      imgSrc: "",
      uploadVisible: false,
      passwordVisible: false,
      userInfo: {}
    };
  },
  created() {
    // console.log("token=" + this.token);
    // alert(this.token);
    if (this.token === "") {
      this.$router.push("/login");
    } else {
      this.initData();
    }
  },
  computed: {
    token() {
      return this.getToken();
    }
  },
  methods: {
    initData() {
      this.tokenBean.token = this.token;
      myInfo(this.tokenBean).then(res => {
        if (res.code === 200) {
          console.log(res.data);
          this.userInfo = res.data.user;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    updPwd() {
      if (this.pwdBean.oldPwd === "") {
        this.$message.error("请输入旧密码。");
        return;
      }
      if (this.pwdBean.loginPwd === "") {
        this.$message.error("请输入新密码。");
        return;
      }
      if (this.pwdBean.loginPwd != this.loginPwd2) {
        this.$message.error("新密码与确认密码不一致");
        return;
      }
      this.pwdBean.token = this.token;
      updPwd(this.pwdBean).then(res => {
        if (res.code === 200) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 重写文件上传方法
    fileUpload(file) {
      this.faceBean.token = this.token;
      if (file.size > 1024 * 1024) {
        this.$message.error("文件大小不能超过1M");
        return;
      }
      this.fileToBase64(file.file)
        .then(res => {
          // console.log(res)
          this.imgSrc = res;
          this.userInfo.faceUrl = res;
          this.faceBean.extName = res.substring(
            res.indexOf("/") + 1,
            res.indexOf(";")
          );
          const len = 19 + this.faceBean.extName.length;
          this.faceBean.fileBase64 = res.substring(len);
          addPerson(this.faceBean).then(res => {
            if (res.code === 200) {
              this.$message.success("上传照片成功");
            } else {
              this.$message.error(res.msg);
            }
          });
          // console.log(this.dataForm.fileBase64)
        })
        .catch(err => {
          console.log(err);
          this.$message.error(err);
        });
    },
    // 转base64
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        let fileResult = "";
        if (file.size > 1024 * 1024 * 4) {
          reject("文件大小不能超过4M");
        }
        reader.readAsDataURL(file);
        // 开始转
        reader.onload = () => {
          fileResult = reader.result;
          // data:image/jpeg;base64,
        };
        // 转 失败
        reader.onerror = function(error) {
          reject(error);
        };
        // 转 结束  咱就 resolve 出去
        reader.onloadend = function() {
          resolve(fileResult);
        };
      });
    },
    showUpload() {
      this.uploadVisible = true;
      this.$nextTick(() => {
        this.$refs.upload.init();
      });
    },
    showPassword() {
      this.passwordVisible = true;
      this.$nextTick(() => {
        this.$refs.updPassword.initData();
      });
    }
  }
};
</script>

<style scoped></style>
